import { lazy } from "react";

export const publicRoutes = [
  {
    path: "/login",
    exact: true,
    element: lazy(() => import("./pages/auth/Login")),
  },
  {
    path: "/forgot-password",
    exact: true,
    element: lazy(() => import("./pages//auth/ForgotPassword")),
  },
  {
    path: "/reset-pw/:token",
    exact: true,
    element: lazy(() => import("./pages/auth/ResetPassword")),
  },
  {
    path: "/403",
    exact: true,
    element: lazy(() => import("./pages/auth/Forbidden")),
  },
  {
    path: "/not-found",
    exact: true,
    element: lazy(() => import("./pages/auth/NotFound")),
  },
];

export const protectedRoutes = [
  // {
  //   path: "*",
  //   element: lazy(() => import("./pages/PageNotFound")),
  // },

  {
    path: "/information/account",
    exact: true,
    element: lazy(() => import("./pages/Account")),
  },
  {
    path: "/testing",
    exact: true,
    element: lazy(() => import("./pages/testing")),
  },

  // Categories
  {
    path: "/admin/categories",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryList")),
  },
  {
    path: "/admin/category/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryForm")),
  },
  {
    path: "/admin/category/create",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryForm")),
  },

  // users
  // /information/update-password
  {
    path: "/information/users",
    exact: true,
    element: lazy(() => import("./pages/users/Users")),
  },
  {
    path: "/information/update-password",
    exact: true,
    element: lazy(() => import("./pages/Updatepassword")),
  },
  {
    path: "/information/users/create",
    exact: true,
    element: lazy(() => import("./pages/users/UsersForm")),
  },
  {
    path: "/information/users/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/users/UsersForm")),
  },

  {
    path: "/information/constants",
    exact: true,
    element: lazy(() => import("./pages/Constants")),
  },
  {
    path: "/information/prompt-reports",
    exact: true,
    element: lazy(() => import("./pages/PromptAndReports")),
  },

  // suppliers

  {
    path: "/admin/supplier",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierList")),
  },
  {
    path: "/admin/supplier/create",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierForm")),
  },
  {
    path: "/admin/supplier/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierForm")),
  },
  //buyers
  {
    path: "/admin/buyers",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerList")),
  },
  {
    path: "/admin/buyers/create",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerForm")),
  },
  {
    path: "/admin/buyers/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerForm")),
  },
  //products
  {
    path: "/admin/products",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductList")),
  },
  {
    path: "/admin/products/create",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductForm")),
  },
  {
    path: "/admin/products/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductForm")),
  },

  //spend group

  {
    path: "/information/spend-group",
    exact: true,
    element: lazy(() => import("./pages/sector/Sector")),
  },
  {
    path: "/information/spend-group/create",
    exact: true,
    element: lazy(() => import("./pages/sector/SectorForm")),
  },
  {
    path: "/information/spend-group/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/sector/SectorForm")),
  },

  //logs
  {
    path: "/information/activity-logs",
    exact: true,
    element: lazy(() => import("./pages/Logs")),
  },
  {
    path: "/information/activity-logs/:id",
    exact: true,
    element: lazy(() => import("./pages/Logs/LogDetails")),
  },

  // org hierarchy
  {
    path: "/information/organization-hierarchy",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchy")),
  },
  {
    path: "/information/organization-hierarchy/create",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },
  {
    path: "/information/organization-hierarchy/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },
  {
    path: "/information/organization-hierarchy/add/:add/:parent",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },

  // Tasks

  {
    path: "/task-list",
    exact: true,
    element: lazy(() => import("./pages/task/TaskList")),
  },
  {
    path: "/task-list/:id",
    exact: true,
    element: lazy(() => import("./pages/task/TaskDetails")),
  },

  {
    path: "/createtarget",
    exact: true,
    element: lazy(() => import("./pages/NewTargetEmmision/Createtarget")),
  },

  {
    path: "/settarget",
    exact: true,
    element: lazy(() => import("./pages/NewTargetEmmision/SetTarget")),
  },

  // activities
  {
    path: "/emission-activities",
    exact: true,
    element: lazy(() => import("./pages/activities/ActivityList")),
  },
  {
    path: "/upload-stream/:type",
    exact: true,
    element: lazy(() => import("./pages/uploadstream/Upload")),
  },
  {
    path: "/emission-activities/create",
    exact: true,
    element: lazy(() =>
      import("./pages/activities/create-activity/CreateActivity")
    ),
  },
  {
    path: "/emission-activities/:inputGroupId",
    exact: true,
    element: lazy(() => import("./pages/activities/Activity")),
  },
  {
    path: "/emission-activities/:inputGroupId/category/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/activities/Activity")),
  },

  {
    path: "/emission-activities/:inputGroupId/category/:categoryId/purchase-goods/:type",
    exact: true,
    element: lazy(() => import("./pages/purchase-goods/PurchaseGoods")),
  },
  {
    path: "/emission-activities/:inputGroupId/category/:categoryId/capital-goods/:type",
    exact: true,
    element: lazy(() => import("./pages/capital-goods/CapitalGoods")),
  },

  {
    path: "/",
    exact: true,
    element: lazy(() => import("./pages/home/Home")),
  },
  {
    path: "/get-started",
    exact: true,
    element: lazy(() => import("./pages/home/GetStarted")),
  },

  //ESG module
  {
    path: "/emission-activities/esg",
    exact: true,
    element: lazy(() => import("./pages/esg/Esgacticity")),
  },
  {
    path: "/emission-activities/esg/create",
    exact: true,
    element: lazy(() => import("./pages/esg/create-activity/CreateActivity")),
  },
  {
    path: "emission-activities/:reportId/esg-module",
    exact: true,
    element: lazy(() => import("./pages/esg/Environmental")),
  },
  {
    path: "/emission-activities/:reportId/esg-module/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/esg/Environmental")),
  },

  // analytics
  {
    path: "/analytics",
    exact: true,
    element: lazy(() => import("./pages/analytics/Analytics")),
  },
  {
    path: "/analytics/:nodeId",
    exact: true,
    element: lazy(() => import("./pages/analytics/SingleNodeAnalyticView")),
  },
  {
    path: "/analytics/:nodeId/:scope/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/analytics/CategoryAnalytics")),
  },
  {
    path: "/analytics/:nodeId/suppliers",
    exact: true,
    element: lazy(() => import("./pages/analytics/SuppliersAnalytics")),
  },
  {
    path: "/analytics/:nodeId/spend-group",
    exact: true,
    element: lazy(() => import("./pages/analytics/SpendGroupAnalytics")),
  },
  // analytics ghg dashboard
  {
    path: "/dashboard",
    exact: true,
    element: lazy(() => import("./pages/dashboard/index")),
  },
  {
    path: "/testing",
    exact: true,
    element: lazy(() => import("./pages/testing")),
  },
  {
    path: "/targetemmision",
    exact: true,
    element: lazy(() => import("./pages/TargetEmission/index")),
  },
  {
    path: "/dashboard/Scopes",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scopes")),
  },
  {
    path: "/dashboard/scope-1",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope1")),
  },

  {
    path: "/dashboard/scope-2",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope2")),
  },
  {
    path: "/dashboard/scope-3 cat1",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3")),
  },
  {
    path: "/dashboard/scope-3 cat2",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3Cat2")),
  },
  {
    path: "/dashboard/scope3-cat5",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3Cat5")),
  },
  {
    path: "/dashboard/scope3-other",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3OtherCat")),
  },

  // emission targets
  {
    path: "/information/emission-targets",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargets")),
  },
  {
    path: "/information/emission-targets/create/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/emission-targets/edit/:id/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/emission-targets/:id/items/:name",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/TargetGroupItem")),
  },
  // {
  //   path: "/information/base-metrics",
  //   exact: true,
  //   element: lazy(() => import("./pages/emission-targets/BaseMetrics")),
  // },
  {
    path: "/information/base-metrics/create/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/base-metrics/edit/:id/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/base-metrics/:id/items/:name",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/TargetGroupItem")),
  },

  //base metrics
  {
    path: "/information/base-metrics",
    exact: true,
    element: lazy(() => import("./pages/metrics")),
  },
  {
    path: "/information/base-metrics/create",
    exact: true,
    element: lazy(() => import("./pages/metrics/CreateForm")),
  },
  {
    path: "/information/base-metrics/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/metrics/CreateForm")),
  },
  {
    path: "/information/base-metrics/:type",
    exact: true,
    element: lazy(() => import("./pages/metrics")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId/:actionType",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  // Uncertainty Analysis
  {
    path: "/information/uncertainty-analysis",
    exact: true,
    element: lazy(() =>
      import("./pages/uncertainty-analysis/UncertaintyAnalysis")
    ),
    element: lazy(() =>
      import("./pages/uncertainty-analysis/UncertaintyAnalysis")
    ),
  },
  // reports
  {
    path: "/reports",
    exact: true,
    element: lazy(() => import("./pages/reports/ReportLanding")),
  },
  {
    path: "/reports/type/:tab",
    exact: true,
    element: lazy(() => import("./pages/reports/Reports")),
  },
  {
    path: "/reports/type/:reportType/create",
    exact: true,
    element: lazy(() => import("./pages/reports/create-reports/CreateReport")),
  },
  {
    path: "/reports/type/:reportType/create-report-gri",
    exact: true,
    element: lazy(() =>
      import("./pages/reports/create-report-gri/CreateReport")
    ),
  },
  {
    path: "/reports/type/activity/create",
    exact: true,
    element: lazy(() => import("./pages/reports/activity/CreateForm")),
  },

  //tcfd reports

  {
    path: "/reports/type/tcfd/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/tcfd/StartPage")),
  },
  {
    path: "/reports/type/tcfd/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/tcfd/index")),
  },

  //gri reports

  {
    path: "/reports/type/gri/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/gri")),
  },
  {
    path: "/reports/type/gri/:reportId/:edit/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/gri")),
  },
  {
    path: "/reports/type/gri/:reportId/:edit",
    exact: true,
    element: lazy(() => import("./pages/reports/gri")),
  },

  // ppn reports
  {
    path: "/reports/type/ppn/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/PPN")),
  },
  {
    path: "/reports/type/ppn/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/PPNSteps")),
  },
  {
    path: "/reports/ppn/policy",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/ProcurementPolicy")),
  },
  // brsr reports
  {
    path: "/reports/type/brsr/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId/:subSectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },

  //GHG reports

  {
    path: "/reports/type/GHG/create",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/CreateReport")),
  },
  {
    path: "/reports/type/GHG/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/GHG")),
  },
  {
    path: "/reports/type/GHG/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/GHGSteps")),
  },
  // {
  //   path: "/reports/GHG/policy",
  //   exact: true,
  //   // element: lazy(() => import("./pages/reports/GHGInventory/ProcurementPolicy")),
  // },

  {
    path: "/upload/:type",
    exact: true,
    element: lazy(() => import("./pages/UploadData")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId/:subSectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },

  {
    path: "/emission-activities/:inputGroupId/supplier",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierActivity")),
  },
  {
    path: "/emission-activities/:inputGroupId/supplier/:supplierId",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierCategoryList")),
  },
  {
    path: "/emission-activities/:inputGroupId/supplier/:supplierId/category/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierCategoryDrawer")),
  },
  {
    path: "/information/supplier-collaboration",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab")),
  },
  {
    path: "/information/supplier-collaboration/:supplier/edit",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab/SupplierDetails")),
  },
  {
    path: "/information/supplier-collaboration/invite",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab/InviteForm")),
  },
  {
    path: "/custumdatastream/:type",
    exact: true,
    element: lazy(() => import("./pages/custumdatastream")),
  },
];

export const supplierPublicRoute = [
  {
    path: "/supplier/login",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages/SupplierLogin")),
  },
];

export const supplierRoutes = [
  {
    path: "*",

    element: lazy(() => import("./pages/suppliers-pages/PageNotFound")),
  },
  {
    path: "/un-authorized",

    element: lazy(() => import("./pages/UnAuthorized")),
  },
  {
    path: "/supplier",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages")),
  },

  {
    path: "/supplier/emission-activities/:inputGroupId",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages/AddData")),
  },
  {
    path: "/supplier/emission-activities/:inputGroupId/category/:categoryId",
    exact: true,
    element: lazy(() =>
      import("./pages/suppliers-pages/SupplierCategoryDrawer")
    ),
  },
];
